import { AUTH_LOGIN_START, AUTH_LOGIN_SUCCESS, AUTH_LOGIN_FAILURE, AUTH_LOGOUT, AUTH_RESTORE_SESSION, AUTH_SET_PERMISSIONS } from "../constants";

const initialState = {
  user: null,
  token: null,
  isAuthenticated: false,
  loading: false,
  error: null,
  permissions: null,
};

export const setAuthLoginStart = () => ({
  type: AUTH_LOGIN_START,
});

export const setAuthLoginSuccess = (user, token) => ({
  type: AUTH_LOGIN_SUCCESS,
  payload: { user, token },
});

export const setAuthLoginFailure = (error) => ({
  type: AUTH_LOGIN_FAILURE,
  payload: error,
});

export const setAuthLogout = () => ({
  type: AUTH_LOGOUT,
});

export const restoreSession = (user, token) => ({
  type: AUTH_RESTORE_SESSION,
  payload: { user, token },
});

export const setPermissions = (permissions) => ({
  type: AUTH_SET_PERMISSIONS,
  payload: permissions,
});

export const auth = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_LOGIN_START:
      return { ...state, loading: true, error: null };
    case AUTH_LOGIN_SUCCESS:
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
        isAuthenticated: true,
        loading: false,
        error: null,
      };
    case AUTH_LOGIN_FAILURE:
      return {
        ...state,
        user: null,
        token: null,
        isAuthenticated: false,
        loading: false,
        error: action.payload,
      };
    case AUTH_LOGOUT:
      return {
        ...state,
        user: null,
        token: null,
        isAuthenticated: false,
        loading: false,
        error: null,
        permissions: null,
      };
    case AUTH_RESTORE_SESSION:
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
        isAuthenticated: true,
        loading: false,
        error: null,
      };
    case AUTH_SET_PERMISSIONS:
      return {
        ...state,
        permissions: action.payload,
      };
    default:
      return state;
  }
};
